module.exports = __webpack_public_path__ + "static/media/16a.a1c6e22c.jpg";